export enum Phase {
  Zero = 'PhaseZero',
  One = 'PhaseOne',
  Two = 'PhaseTwo',
  Three = 'PhaseThree',
  Four = 'PhaseFour',
}

export enum CareModel {
  Collaborative = 'Collaborative',
  CoachOnly = 'Coach-only',
  DigitalOnly = 'Digital-only',
}

export type RiskLevel = 'Low' | 'Moderate' | 'High';

export enum AppOnboardingStatus {
  BaselineComplete = 'Baseline complete',
  Onboarding = 'Onboarding',
  NeverLoggedIn = 'Never logged in',
}

export type User = {
  id: string;
  affiliate?: string;
  // When populated, it is the date the user canceled
  canceled?: string;
  care_model: CareModel;
  email: string;
  phone_number?: string;
  birthdate: string;
  first_name: string;
  last_name: string;
  legal_name?: string | null;
  address_street?: string;
  address_city?: string;
  address_state?: string;
  address_zip?: string;
  current_phase: Phase;
  sex: string;
  gender: string;
  healthie_id?: number;
  ethnicity: string;
  allergens: string[];
  diet_restrictions: string[];
  selected_foods: string[];
  plan_name?: string;
  subscription_id: string;
  coach_id: string;
  intercom_id: string | null;
  created_at: string;
  health_plan_member_id: string | null;
  health_system?: string;
  pregnant_when_onboarded: null | 'Currently' | 'No' | 'Nursing' | 'Planning';
  history_of_disordered_eating?: boolean;
  history_of_gi_surgery?: boolean;
  timezone: string;
  amount_completed_gut_checks: number | null;
  last_gut_check: string | null;
  app_onboarding_status?: AppOnboardingStatus | null;
  last_engaged: string | null
  patient_summary?: string | null;
};
